export default function getYouTubeVideoId(url) {
    // Define the regular expression pattern for matching YouTube URLs
    var pattern = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    // Use the pattern to match the URL and extract the video ID
    var match = url.match(pattern);

    // If a match is found, return the video ID, otherwise return null
    return (match && match[1]) ? match[1] : null;
}